module.exports = __webpack_public_path__ + "deathlyHallows.5aa92f89.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/components/routes/ItemView/images/deathlyHallows.svg
// module id = 76jL
// module chunks = 0